import React, {useState, useEffect} from "react"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "./datefield.scss"

export default function DateField({json, dependencies, onFieldChange})
{
    const [selected, setSelected] = useState(null)
    const [humanDate, setHumanDate] = useState()
    const [years, setYears] = useState()
    const [isOpen, setIsOpen] = useState(false)   
    const [input, setInput] = useState()
    const [min, setMin] = useState()
    const [max, setMax] = useState()

    const months = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ]

    const setInputValues = (date) =>
    {
        setInput(new Date(date).getTime())
    }

    const getHumanDate = (d)  =>
    {        
        const date = d === '' ? new Date() : new Date(d)
        return date.toLocaleDateString()
    }

    const handleChange = (e) => 
    {
        setIsOpen(!isOpen)
        setSelected(e)
        setInputValues(e)
        setHumanDate(getHumanDate(e))
        if(dependencies) dependencies(json.key, e)
        if(onFieldChange) onFieldChange(json.key, e)
    }

    const handleClick = (e) => 
    {
        e.preventDefault()
        setIsOpen(!isOpen)
    }

    const getYear = (date) =>
    {
        return date.getFullYear()
    }

    const getMonth = (date) =>
    {
        return date.getMonth()
    }

    useEffect(() =>
    {
        const getFrom = () =>
        {
            const date = new Date()

            if(!json.years_before)
            {
                return date.getFullYear()-100
            } 

            return date.getFullYear()-parseInt(json.years_before)          
        }

        const from = getFrom()

        setMin(()=>
        {            
            if(!json.only_future)
            {            
                return null 
            }
            
            return new Date()
        })

        const getTo = () =>
        {
            const date = new Date()
            
            if(!json.years_after)
            {
                return date.getFullYear()+100            
            }

            return date.getFullYear()+parseInt(json.years_after)
        }

        const to = getTo()

        const select = json.value ? new Date(json.value) : new Date()

        setSelected(select)
        setInputValues(select.getTime())
        
        setYears(() =>
        {
            const start = from
            const end = to
            const range = []
    
            for (let year = start; year <= end; year++) 
            {
                range.push(year)
            }   
            
            return range
        })

        setHumanDate(getHumanDate(json.value || ''))

    },[])

    return (
        <div className={"json-input datepicker field_"+json.key}>
            {json.label && <label for={json.key} dangerouslySetInnerHTML={{__html: json.label}} />}
            <div className="field">
                <div className="input" onClick={handleClick}>{humanDate}</div>
                <input className={'input_'+json.key} type="hidden" name={json.key} value={input} />
                <img onClick={handleClick} src="../calendar.svg" />
            </div>
            {isOpen && (
                <DatePicker
                    inline
                    dateFormat="MMMM d, yyyy"
                    onChange={handleChange}
                    minDate={min}
                    maxDate={max}
                    peekNextMonth
                    showMonthDropdown
                    disabledKeyboardNavigation
                    showYearDropdown
                    dropdownMode="select"
                    selected={selected}
                    renderCustomHeader={({
                        date,
                        changeYear,
                        changeMonth,
                        decreaseMonth,
                        increaseMonth,
                        prevMonthButtonDisabled,
                        nextMonthButtonDisabled,
                    }) => (
                        <div
                            style={{
                                margin: 10,
                                display: "flex",
                                justifyContent: "center",
                            }}>
                            <button className="button" onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>{"<"}</button>
                            <select className="selector" value={getYear(date)} onChange={({ target: { value } }) => changeYear(value)}>
                                {
                                    years.map((option) => 
                                    {
                                        return(
                                            <option key={option} value={option}>
                                                {option}
                                            </option>
                                        )
                                    })
                                }
                            </select>
                            <select className="selector" value={months[getMonth(date)]} onChange={({ target: { value } }) => changeMonth(months.indexOf(value))}>
                            {
                                months.map((option) => 
                                {
                                    return(
                                        <option key={option} value={option}>
                                            {option}
                                        </option>
                                    )
                                })
                            }
                            </select>
                            <button className="button" onClick={increaseMonth} disabled={nextMonthButtonDisabled}>{">"}</button>
                        </div>
                    )}
                    />                                
            )}                            
        </div>
    )
}